import {
  CommonRequest,
  CommonResponse,
  Method,
  ServiceName,
  SuccessOrNot,
} from 'models/common/RestApi';
import { MachineDetail, UtComparisonLineInfo, UtComparisonMatrix } from 'models/ut/UtComparison';
import { callApi } from 'utils/ApiUtil';

/**
 * UT 사용량 비교 (정합화 Report) — 조회 API
 *
 * pages/ut/api.ts 가 이 모듈만 바라보므로, 백엔드 URL이 다를 경우 아래 url 값만 교체하면 된다.
 */

/**
 * callApi 는 404/500 에서도 예외를 던지지 않고 successOrNot='N' 응답을 돌려준다.
 * 그대로 빈 배열을 반환하면 화면이 "데이터 0건"으로 조용히 렌더링되어 원인 파악이 어려우므로,
 * 여기서 예외로 승격시켜 store 의 runAnalyze() catch 가 사용자에게 알리도록 한다.
 */
const unwrap = <T>(response: CommonResponse<T[]>, label: string): T[] => {
  if (response.successOrNot !== SuccessOrNot.Y) {
    throw new Error(`${label} 조회에 실패했습니다. (statusCode: ${response.statusCode})`);
  }
  return (response.data ?? []) as T[];
};

/** 비교 대상으로 선택 가능한 UT Matrix 목록 */
export const findUtMatrices = async () => {
  const request: CommonRequest = {
    method: Method.GET,
    url: `/v1/ut/ut-comparison/ut-matrices`,
    serviceName: ServiceName.ELM_BE,
  };
  const response: CommonResponse<UtComparisonMatrix[]> = await callApi(request);
  return (response.successOrNot === 'Y' ? response.data : []) as UtComparisonMatrix[];
};

/** 설비군별 라인수량 (1라인별 사용량 비교 모드) */
export const findLineInfo = async (utmIds: string[]) => {
  const request: CommonRequest = {
    method: Method.GET,
    url: `/v1/ut/ut-comparison/line-info`,
    serviceName: ServiceName.ELM_BE,
    queryParams: new URLSearchParams({ utmIds: (utmIds || []).join(',') }),
  };
  const response: CommonResponse<UtComparisonLineInfo[]> = await callApi(request);
  return (response.successOrNot === 'Y' ? response.data : []) as UtComparisonLineInfo[];
};

/** Machine 단위 UT 사용량 상세 (비교 대상 UTM_ID 전체분) */
export const findMachineDetail = async (utmIds: string[]) => {
  const request: CommonRequest = {
    method: Method.GET,
    url: `/v1/ut/ut-comparison/machine-detail`,
    serviceName: ServiceName.ELM_BE,
    queryParams: new URLSearchParams({ utmIds: (utmIds || []).join(',') }),
  };
  const response: CommonResponse<MachineDetail[]> = await callApi(request);
  return (response.successOrNot === 'Y' ? response.data : []) as MachineDetail[];
};
